import dayjs from "dayjs";
import ptBR from "dayjs/locale/pt-br";
import Button from "../Button";

export default function DateRangePerMonth({ dateState, size = 'lg', onDateSelect }: {
    dateState: {
        startDate: Date,
        endDate: Date,
    }
    onDateSelect: ({
        startDate,
        endDate
    }: {

        startDate: Date,
        endDate: Date,

    }) => void
    size?: 'sm' | 'lg'
}) {
    function onNextMonth() {
        const newDate = dayjs(dateState.startDate).add(1, 'month');
        onDateSelect({ startDate: newDate.startOf('month').toDate(), endDate: newDate.endOf('month').toDate() });
    }

    function onPrevMonth() {
        const newDate = dayjs(dateState.startDate).subtract(1, 'month');
        onDateSelect({ startDate: newDate.startOf('month').toDate(), endDate: newDate.endOf('month').toDate() });
    }

    return (
        <div className="d-flex align-items-center gap-1">
            <Button onClick={onPrevMonth} variant="secondary" icon="bi-arrow-left" className="btn-icon btn-sm flex-shrink-0" />
            <input className="form-control form-control-sm text-center" value={dayjs(dateState.startDate).locale(ptBR).format('MMMM YYYY')} readOnly />
            <Button onClick={onNextMonth} variant="secondary" icon="bi-arrow-right" className="btn-icon btn-sm flex-shrink-0" />
        </div>
    )
}